// extracted by mini-css-extract-plugin
module.exports = {"progress":"styles_progress__gXoYO","title":"styles_title__7fNdy"};